/**
 * The table socket's session (review 0016, 0019 U8): offered as a WebSocket subprotocol, never in the
 * URL, because platform logs keep request URLs. A subprotocol must be an HTTP token, so the session
 * rides base64url-encoded after a fixed prefix; the server answers with `SOCKET_PROTOCOL`. Pure.
 */
export const SOCKET_PROTOCOL = "hcc.v1";
const SESSION_PREFIX = "hcc.session.";
function toBase64Url(text) {
    const bytes = new TextEncoder().encode(text);
    let binary = "";
    for (const byte of bytes)
        binary += String.fromCharCode(byte);
    return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
function fromBase64Url(encoded) {
    if (!/^[A-Za-z0-9_-]+$/.test(encoded))
        return null;
    try {
        const binary = atob(encoded.replace(/-/g, "+").replace(/_/g, "/"));
        return new TextDecoder().decode(Uint8Array.from(binary, (char) => char.charCodeAt(0)));
    }
    catch {
        return null;
    }
}
/** What the client offers when it opens the table socket. */
export function socketProtocols(session) {
    return [SOCKET_PROTOCOL, `${SESSION_PREFIX}${toBase64Url(session)}`];
}
/** The session in a `Sec-WebSocket-Protocol` header; null when the header carries none. */
export function sessionFromProtocols(header) {
    const offered = (header ?? "").split(",").map((value) => value.trim());
    if (!offered.includes(SOCKET_PROTOCOL))
        return null;
    const carrier = offered.find((value) => value.startsWith(SESSION_PREFIX));
    return carrier === undefined ? null : fromBase64Url(carrier.slice(SESSION_PREFIX.length));
}
//# sourceMappingURL=socketAuth.js.map